const neozon = {
  env: "neozon",
  api: {
    URL: "http://partner.just.ddns.me",
  },
  captcha: {
    ENABLED: true,
    SITE_KEY: "6Ld_IuspAAAAAFW0k83N1eGorXsFiWEM2j78a0qg"
  }
};

const test = {
  env: "test",
  api: {
    URL: "http://seeyou.test.just.ddns.me/partner",
  },
  captcha: {
    ENABLED: true,
    SITE_KEY: "6Ld_IuspAAAAAFW0k83N1eGorXsFiWEM2j78a0qg"
  }
};

const prod = {
  env: "prod",
  api: {
    URL: "https://app.bumpin.pro/partner",
  },
  captcha: {
    ENABLED: true,
    SITE_KEY: "6LdAGQUqAAAAAMjrT5iRdWbnmHt3VF4KjhDM0xs8"
  }
};

const vultr = {
  env: "vultr",
  api: {
    URL: "https://app3.bumpin.pro/partner",
  },
  captcha: {
    ENABLED: true,
    SITE_KEY: "6LdAGQUqAAAAAMjrT5iRdWbnmHt3VF4KjhDM0xs8"
  }
};


const getAppConf = () => {
  switch (process.env.REACT_APP_STAGE) {
    case "test1":
      return test
  
    case "prod4":
      return prod

    case "vultr":
      return vultr
  
    default:
      return neozon;
  }
}

export default getAppConf();
